import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  MatFormFieldDefaultOptions,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from '../app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTreeModule } from '@angular/material/tree';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { QuillModule } from 'ngx-quill';
import { RouterModule, PreloadAllModules, Routes } from '@angular/router';
import { ClBaseComponent } from './checklist-components/cl-base/cl-base.component';
import { ButtonSignatureComponent } from './checklist-components/button-signature/button-signature.component';
import { MasterControlComponent } from './checklist-components/master-control/master-control.component';
import { CheckboxSignatureComponent } from './checklist-components/checkbox-signature/checkbox-signature.component';
import { QuestionSignatureComponent } from './checklist-components/question-signature/question-signature.component';
import { ClCloseActionComponent } from './checklist-components/cl-close-action/cl-close-action.component';
import { FormWorkflowComponent } from 'src/app/common/form-workflow/form-workflow.component';
import { ClCheckboxComponent } from './checklist-components/cl-checkbox/cl-checkbox.component';
import { ClCheckboxAndRadioComponent } from './checklist-components/cl-checkbox-and-radio/cl-checkbox-and-radio.component';
import { ClNoteComponent } from './checklist-components/cl-note/cl-note.component';
import { ClScheduleAndCheckboxComponent } from './checklist-components/cl-schedule-and-checkbox/cl-schedule-and-checkbox.component';
import { ClCheckboxAndTextInputComponent } from './checklist-components/cl-checkbox-and-text-input/cl-checkbox-and-text-input.component';
import { ClCommentsComponent } from './checklist-components/cl-comments/cl-comments.component';
import { ClCheckboxMultipleComponent } from './checklist-components/cl-checkbox-multiple/cl-checkbox-multiple.component';
import { ClEditorComponent } from './checklist-components/cl-editor/cl-editor.component';
import { ClEditorScheduleComponent } from './checklist-components/cl-editor/cl-editor-schedule/cl-editor-schedule.component';
import { ClEditorStatusComponent } from './checklist-components/cl-editor/cl-editor-status/cl-editor-status.component';
import { ClEditorTagInfoComponent } from './checklist-components/cl-editor/cl-editor-tag-info/cl-editor-tag-info.component';
import { ClEditorPlaceholderSelectComponent } from './checklist-components/cl-editor/cl-editor-placeholder-select/cl-editor-placeholder-select.component';
import { ClEditorRadioOptionsComponent } from './checklist-components/cl-editor/cl-editor-radio-options/cl-editor-radio-options.component';
import { ClEditorCheckboxOptionsComponent } from './checklist-components/cl-editor/cl-editor-checkbox-options/cl-editor-checkbox-options.component';
import { ClEditorTextboxOptionsComponent } from './checklist-components/cl-editor/cl-editor-textbox-options/cl-editor-textbox-options.component';
import { ClEditorLocationComponent } from './checklist-components/cl-editor/cl-editor-location/cl-editor-location.component';
import { ClEditorColorsComponent } from './checklist-components/cl-editor/cl-editor-colors/cl-editor-colors.component';
import { ClEditorBRATOIComponent } from './checklist-components/cl-editor/cl-editor-bratoi/cl-editor-bratoi.component';
import { ClEditorSublocationsComponent } from './checklist-components/cl-editor/cl-editor-sublocations/cl-editor-sublocations.component';
import { ClEditorTableHeadersComponent } from './checklist-components/cl-editor/cl-editor-table-headers/cl-editor-table-headers.component';
import { ClEditorImageComponent } from './checklist-components/cl-editor/cl-editor-image/cl-editor-image.component';
import { ClEditorHideDisableToggleComponent } from './checklist-components/cl-editor/cl-editor-hide-disable-toggle/cl-editor-hide-disable-toggle.component';
import { ClEditorPlaceholderOptionsComponent } from './checklist-components/cl-editor/cl-editor-placeholder-options/cl-editor-placeholder-options.component';
import { ClEditorCheckboxRolesSelectionComponent } from './checklist-components/cl-editor/cl-editor-checkbox-roles/cl-editor-checkbox-roles-selection/cl-editor-checkbox-roles-selection.component';
import { ClEditorCheckboxRolesComponent } from './checklist-components/cl-editor/cl-editor-checkbox-roles/cl-editor-checkbox-roles.component';
import { ClCheckboxAndCommentsComponent } from './checklist-components/cl-checkbox-and-comments/cl-checkbox-and-comments.component';
import { ClCatlComponent } from './checklist-components/cl-catl/cl-catl.component';
import { ClScheduleAbsiComponent } from './checklist-components/cl-schedule-absi/cl-schedule-absi.component';
import { ClCheckboxMultipleWithTextBoxComponent } from './checklist-components/cl-checkbox-multiple-with-textbox/cl-checkbox-multiple-with-textbox.component';
import { ClSubtitleComponent } from './checklist-components/cl-subtitle/cl-subtitle.component';
import { ClMultipleTextboxComponent } from './checklist-components/cl-multiple-textbox/cl-multiple-textbox.component';
import { ClShieldingsComponent } from './checklist-components/cl-shieldings/cl-shieldings.component';
import { ClTextComponent } from './checklist-components/cl-text/cl-text.component';
import { ClOlogComponent } from './checklist-components/cl-olog/cl-olog.component';
import { ClStatusChangeComponent } from './checklist-components/cl-status-change/cl-status-change.component';
import { ClMultipleStatusChangeComponent } from './checklist-components/cl-multiple-status-change/cl-multiple-status-change.component';
import { ClRadMetersComponent } from './checklist-components/cl-rad-meters/cl-rad-meters.component';
import { ClRadMetersAddComponent } from './checklist-components/cl-rad-meters/cl-rad-meters-add/cl-rad-meters-add.component';
import { ClImageUploadComponent } from './checklist-components/cl-image-upload/cl-image-upload.component';
import { ClImageUploadTableComponent } from './checklist-components/cl-image-upload/cl-image-upload-table/cl-image-upload-table.component';
import { ClImageUploadTableDataComponent } from './checklist-components/cl-image-upload/cl-image-upload-table/cl-image-upload-table-data/cl-image-upload-table-data.component';
import { ClImageUploadInfoComponent } from './checklist-components/cl-image-upload/cl-image-upload-info/cl-image-upload-info.component';
import { ClEditorTableChannelsAddComponent } from './checklist-components/cl-image-upload/cl-image-upload-table/cl-image-upload-table-data/cl-editor-table-channels-add/cl-editor-table-channels-add.component';
import { ButtonSignatureDuplicateComponent } from './checklist-components/button-signature-duplicate/button-signature-duplicate.component';
import { ClLocationComponent } from './checklist-components/cl-location/cl-location.component';
import { ClBRATOIComponent } from './checklist-components/cl-bratoi/cl-bratoi.component';
import { ClCheckboxMultipleSignComponent } from './checklist-components/cl-checkbox-multiple-sign/cl-checkbox-multiple-sign.component';
import { ClCheckboxRadioLocationComponent } from './checklist-components/cl-checkbox-radio-location/cl-checkbox-radio-location.component';
import { ClRadioPlaceholderCondComponent } from './checklist-components/cl-radio-placeholder-cond/cl-radio-placeholder-cond.component';
import { ClRadMonitorComponent } from './checklist-components/cl-rad-monitor/cl-rad-monitor.component';
import { ClRadLocationComponent } from './checklist-components/cl-rad-location/cl-rad-location.component';
import { ClRestrictionsComponent } from './checklist-components/cl-restrictions/cl-restrictions.component';
import { ClRestrictionsByFormComponent } from './checklist-components/cl-restrictions-by-form/cl-restrictions-by-form.component';
import { ClBrcFormsComponent } from './checklist-components/cl-brc-forms/cl-brc-forms.component';
import { ClVacuumsComponent } from './checklist-components/cl-vacuums/cl-vacuums.component';
import { ClShieldingsKeComponent } from './checklist-components/cl-shieldings-ke/cl-shieldings-ke.component';

import { ButtonSignatureRadioComponent } from './checklist-components/button-signature-radio/button-signature-radio.component';
import { OpApprovalWChecklistsComponent } from './checklist-components/op-approval-w-checklists/op-approval-w-checklists.component';
import { ChecklistStatusComponent } from './checklist-status/checklist-status.component';
import { DocumentChipsComponent } from './checklist-chips/document-chips.component';
import { ClRadMonitorDueDateComponent } from './checklist-components/cl-rad-monitor-due-date/cl-rad-monitor-due-date.component';
import { ClEditorRadMonitorsComponent } from './checklist-components/cl-editor/cl-editor-rad-monitors/cl-editor-rad-monitors.component';
import { ClEditorRadLocationsComponent } from './checklist-components/cl-editor/cl-editor-rad-locations/cl-editor-rad-locations.component';
import { ClEditorStatusChangeComponent } from './checklist-components/cl-editor/cl-editor-status-change/cl-editor-status-change.component';
import { ClEditorMultipleStatusChangeComponent } from './checklist-components/cl-editor/cl-editor-multiple-status-change/cl-editor-multiple-status-change.component';
import { PlaceholderHighlightPipe } from 'src/app/common/pipes/placeholder-highlight-pipe.pipe';
import { RoleSelectionComponent } from './role-selection/role-selection.component';
import { CommentsBoxModule } from './comments-box/comments-box.module';
import { CatlComponent } from './catl/catl.component';
import { RoleChipsComponent } from './role-chips/role-chips.component';
import { ClEditorConditionsHelpComponent } from './checklist-components/cl-editor/cl-editor-conditions-help/cl-editor-conditions-help.component';
import { ClEditorComponentHelpComponent } from './checklist-components/cl-editor/cl-editor-component-help/cl-editor-component-help.component';
import { ActionItemComponent } from './catl/action-item/action-item.component';
import { MatCheckboxWithLabelComponent } from './mat-checkbox-with-label/mat-checkbox-with-label.component';
import { MatCheckboxWithRolesComponent } from './mat-checkbox-with-roles/mat-checkbox-with-roles.component';
import { WaitingDotsComponent } from './waiting-dots/waiting-dots.component';
import { WaitingTextComponent } from './waiting-text/waiting-text.component';
import { ClEditorNextStepComponent } from './checklist-components/cl-editor/cl-editor-next-step/cl-editor-next-step.component';
import { InitialsChipComponent } from './initials-chip/initials-chip.component';
import { ClEditorChecklistTypeSelectorComponent } from './checklist-components/cl-editor/cl-editor-checklist-type-selector/cl-editor-checklist-type-selector.component';
import { ErrorSubscriptComponent } from './error-subscript/error-subscript.component';
import { ResizableDirective } from 'src/app/common/directives/resizable.directive';
import { StripSpacesDirective } from 'src/app/common/directives/strip-spaces.directive';
import { UppercaseDirective } from 'src/app/common/directives/uppercase.directive';
import { Highlight } from 'ngx-highlightjs';
import { TagsChipsComponent } from './tags-chips/tags-chips.component';
import { RadsTableHistoryComponent } from './checklist-components/cl-image-upload/rads-table-history/rads-table-history.component';
import { MatSliderModule } from '@angular/material/slider';
import { ClImageUploadContentComponent } from './checklist-components/cl-image-upload/cl-image-upload-content/cl-image-upload-content.component';
import { ImageTablePopupComponent } from './checklist-components/cl-image-upload/image-table-popup/image-table-popup.component';
import { WorkerVerificationWarningComponent } from './worker-verification/worker-verification-warning/worker-verification-warning.component';
import { ClEditorRestrictionToggleComponent } from './checklist-components/cl-editor/cl-editor-restriction-toggle/cl-editor-restriction-toggle.component';
import { DateAndSignComponent } from './date-and-sign/date-and-sign.component';


const appRoutes: Routes = [];

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

@NgModule({
  declarations: [
    ClScheduleAndCheckboxComponent,
    ClCheckboxAndCommentsComponent,
    ClEditorComponent,
    ClEditorRadioOptionsComponent,
    ClCommentsComponent,
    ClEditorScheduleComponent,
    ClCatlComponent,
    ClSubtitleComponent,
    ClNoteComponent,
    ClCheckboxAndTextInputComponent,
    ClCheckboxMultipleComponent,
    ClCheckboxMultipleWithTextBoxComponent,
    ClMultipleTextboxComponent,
    ClCheckboxComponent,
    ClCheckboxAndRadioComponent,
    ClCheckboxRadioLocationComponent,
    ClEditorCheckboxOptionsComponent,
    ClEditorTextboxOptionsComponent,
    ClScheduleAbsiComponent,
    ClTextComponent,
    ClImageUploadComponent,
    ClImageUploadTableComponent,
    ClImageUploadTableDataComponent,
    ClImageUploadInfoComponent,
    ClEditorTableChannelsAddComponent,
    ClEditorLocationComponent,
    ClEditorColorsComponent,
    ClEditorTableHeadersComponent,
    ClEditorImageComponent,
    ClCloseActionComponent,
    ClEditorBRATOIComponent,
    ClEditorHideDisableToggleComponent,
    ClBRATOIComponent,
    ClOlogComponent,
    ClRadMonitorComponent,
    ClStatusChangeComponent,
    ClMultipleStatusChangeComponent,
    ClEditorStatusComponent,
    ClRadLocationComponent,
    ClRadMetersComponent,
    ClRadMetersAddComponent,
    ClRestrictionsComponent,
    ClRestrictionsByFormComponent,
    ClBrcFormsComponent,
    ClVacuumsComponent,
    ClShieldingsKeComponent,
    ClShieldingsComponent,
    ClLocationComponent,
    ClRadMonitorDueDateComponent,
    ClEditorRadMonitorsComponent,
    ClEditorRadLocationsComponent,

    // Signatures
    ButtonSignatureComponent,
    ButtonSignatureDuplicateComponent,
    CheckboxSignatureComponent,
    QuestionSignatureComponent,

    // General
    MasterControlComponent,
    MatCheckboxWithRolesComponent,
    MatCheckboxWithLabelComponent,
    ClBaseComponent,
    FormWorkflowComponent,

    // Directives
    ClEditorTagInfoComponent,
    ClCheckboxMultipleSignComponent,
    ClEditorCheckboxRolesComponent,
    ClEditorCheckboxRolesSelectionComponent,
    ClRadioPlaceholderCondComponent,
    ClEditorPlaceholderSelectComponent,
    ClEditorPlaceholderOptionsComponent,
    ClEditorSublocationsComponent,
    OpApprovalWChecklistsComponent,
    ButtonSignatureRadioComponent,

    ChecklistStatusComponent,
    DocumentChipsComponent,
    ClEditorStatusChangeComponent,
    ClEditorMultipleStatusChangeComponent,
    RoleSelectionComponent,
    CatlComponent,
    RoleChipsComponent,
    ClEditorConditionsHelpComponent,
    ClEditorComponentHelpComponent,

    ActionItemComponent,
    WaitingDotsComponent,
    WaitingTextComponent,
    ErrorSubscriptComponent,
    ClEditorNextStepComponent,
    InitialsChipComponent,
    ClEditorChecklistTypeSelectorComponent,
    PlaceholderHighlightPipe,
    StripSpacesDirective,
    UppercaseDirective,
    ResizableDirective,
    TagsChipsComponent,
    RadsTableHistoryComponent,
    ClImageUploadContentComponent,
    ImageTablePopupComponent,
    WorkerVerificationWarningComponent,
    ClEditorRestrictionToggleComponent,
    DateAndSignComponent
  ],
  imports: [
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatExpansionModule,
    MatOptionModule,
    CommonModule,
    MatSidenavModule,
    CommentsBoxModule,
    MatSliderModule,
    QuillModule.forRoot(),
    RouterModule.forRoot(appRoutes, {
      enableTracing: true,
      useHash: true,
      anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules,
    }),
    Highlight,
  ],
  exports: [
    MasterControlComponent,
    ClEditorComponent,
    ClCloseActionComponent,
    ButtonSignatureComponent,
    CheckboxSignatureComponent,
    QuestionSignatureComponent,
    DocumentChipsComponent,
    FormWorkflowComponent,
    RoleSelectionComponent,
    CatlComponent,
    ActionItemComponent,
    WaitingDotsComponent,
    WaitingTextComponent,
    ClOlogComponent,
    RoleChipsComponent,
    MatCheckboxWithLabelComponent,
    MatCheckboxWithRolesComponent,
    ErrorSubscriptComponent,
    ErrorSubscriptComponent,
    StripSpacesDirective,
    UppercaseDirective,
    ResizableDirective,
    PlaceholderHighlightPipe,
    ClEditorConditionsHelpComponent,
    TagsChipsComponent,
    RadsTableHistoryComponent,
    WorkerVerificationWarningComponent
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ControlsModule { }
